import { createTheme } from '@mui/material/styles';
import { createSelector } from 'reselect';

import { checkIsDarkTheme } from 'utils/theme';

import { selectIsDesktop } from './globalUi.selectors';

export const getSettings = ({ settings }) => settings;

const selectCurrentSettings = createSelector(getSettings, ({ current }) => current);

export const selectCurrentThemeMode = createSelector(
  selectCurrentSettings,
  ({ themeMode }) => themeMode,
);

const selectThemesConfigs = createSelector(getSettings, ({ themes }) => themes);

const createThemeWithCompatPaletteType = themeConfig => {
  const theme = createTheme(themeConfig);
  const mode = theme.palette.mode || themeConfig?.palette?.mode || themeConfig?.palette?.type;

  return {
    ...theme,
    palette: {
      ...theme.palette,
      type: mode,
    },
  };
};

export const selectThemeCoreDesignSystem = createSelector(
  selectThemesConfigs,
  selectCurrentThemeMode,
  ({ coreDesignSystem, coreDesignSystemDark }, themeMode) =>
    createThemeWithCompatPaletteType(
      checkIsDarkTheme(themeMode) ? coreDesignSystemDark : coreDesignSystem,
    ),
);

export const selectLayoutConfig = createSelector(
  selectCurrentSettings,
  ({ layout }) => layout.config,
);

export const selectIsSidebarInDrawer = createSelector(selectIsDesktop, isDesktop => !isDesktop);

const selectLayoutState = createSelector(getSettings, ({ layoutState }) => layoutState);

export const selectSidebarState = createSelector(selectLayoutState, ({ sidebar }) => sidebar);
